import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetSellersOutput } from './GetSellersOutput';

export class GetSellersService extends HttpServiceBase {

  handle = (): Promise<Result<GetSellersOutput> | null> => {
    const promise = this.http.get<Result<GetSellersOutput>>(`${this.baseUrlSislogApi}/v2/seller`);
    return promise;
  }
}